
const getPaymentCustomerByLocationIdQuery = `
  select
    pc.*
  from avocado.payment_customers pc
  where pc.location_id = $1
`

const getUserEmailsByLocationIdQuery = `
  SELECT email FROM avocado.data_user WHERE location_id = $1
`

module.exports = {
  getPaymentCustomerByLocationIdQuery,
  getUserEmailsByLocationIdQuery
}
